import FloatyText from "./FloatyText";
import HyperlinkText from "./HyperlinkText";
import RichTextTokenParser from "./RichTextTokenParser";
import { UnderlinedTextDecorator } from "./UnderlinedTextDecorator";

export default class RichTextRenderer {
    constructor(styling, container) {
        this._styling = styling;
        this._container = container;

        this._currentLine = 0;
        this._currentX = 0;
        this._textHeight = 0;
        this._textColor = "#000";

        this._displayObjects = [];
    }

    destroy() {
        this._displayObjects.forEach(function (obj) {
            if (obj.parent != null) {
                obj.parent.removeChild(obj);
            }
        });
    }

    renderLines(linesData, align, lineHeight, color) {
        linesData.forEach(function (lineData) {
            this.renderLine(lineData, align, lineHeight, color);
        }.bind(this));
    }

    renderLine(lineData, align, lineHeight, color) {
        this._currentX = this._computeStartX(lineData, align);
        this._textHeight = lineHeight;
        if (color) this._textColor = color;

        lineData.wordsData.forEach(function (wordData) {
            var token = RichTextTokenParser.parse(wordData);
            this.renderWord(token);
        }.bind(this));

        this._currentX = 0;
        this._currentLine++;
    }

    renderWord(token) {
        var textInstance;
        switch (token.tag) {
            case 'a':
                textInstance = this.renderAnchorText(token);
                break;
            case 'b':
                textInstance = this.renderBoldText(token);
                break;
            case 'i':
                textInstance = this.renderItalicText(token);
                break;
            case 'u':
                textInstance = this.renderUnderlinedText(token);
                break;
            case 'bi':
            case 'ib':
                textInstance = this.renderBoldItalicText(token);
                break;
            case 'floaty':
                textInstance = this.renderFloatyText(token);
                break;
            case undefined:
            default:
                textInstance = this.renderTextDefault(token);
                break;
        }
        this._displayObjects.push(textInstance);
        this._currentX += token.width;
    }

    renderAnchorText(token) {
        var color = token.attributes.color || this._styling.a.color || this._textColor;
        var renderedText = new HyperlinkText(token.text, this._styling.a.font, color, this._styling.a, token.attributes.href);
        this._addRenderedTextToContainer(renderedText);
        UnderlinedTextDecorator(renderedText)();
        renderedText.updateHitArea();
        this._displayObjects.push(renderedText.underline);

        return renderedText;
    }

    renderBoldText(token) {
        var renderedText = new createjs.Text(token.text, this._styling.b.font, token.attributes.color || this._textColor);
        this._addRenderedTextToContainer(renderedText);

        return renderedText;
    }

    renderItalicText(token) {
        var renderedText = new createjs.Text(token.text, this._styling.i.font, token.attributes.color || this._textColor);
        this._addRenderedTextToContainer(renderedText);

        return renderedText;
    }

    renderBoldItalicText(token) {
        var renderedText = new createjs.Text(token.text, this._styling.bi.font, token.attributes.color || this._textColor);
        this._addRenderedTextToContainer(renderedText);

        return renderedText;
    }

    renderUnderlinedText(token) {
        var renderedText = new createjs.Text(token.text, this._styling._default.font, token.attributes.color || this._textColor);
        this._addRenderedTextToContainer(renderedText);
        UnderlinedTextDecorator(renderedText)();
        this._displayObjects.push(renderedText.underline);

        return renderedText;
    }

    renderFloatyText(token) {
        var renderedText = new FloatyText(token.text, this._styling._default.font, token.attributes.color || this._textColor);
        this._addRenderedTextToContainer(renderedText);

        return renderedText;
    }

    renderTextDefault(token) {
        var renderedText = new createjs.Text(token.text, this._styling._default.font, token.attributes.color || this._textColor);
        this._addRenderedTextToContainer(renderedText);
        return renderedText;
    }

    _computeStartX(lineData, align) {
        switch (align) {
            case "right":
                return -lineData.width;
            case "center":
                return -lineData.width / 2;
            case "left":
            default:
                return 0;
        }
    }

    _addRenderedTextToContainer(renderedText) {
        renderedText.x = this._currentX;
        renderedText.y = this._currentLine * this._textHeight;

        this._container.addChild(renderedText);
    }
}